import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

import { SCOUT_VARIATION_SCORES } from '../../../../../../../constants';

import scss from './ScoresSection.module.scss';

function ScoresSection() {
  const { t } = useTranslation('scout');

  const variationScores = useSelector((state) => state.scout.variationScore);
  const isVariationLoading = useSelector((state) => state.scout.isVariationLoading);

  return (
    <div className={scss.scoresWrapper}>
      {SCOUT_VARIATION_SCORES.map(({ value, label }) => (
        <div key={label} className={scss.scoreWrapper}>
          <span className={scss.label}>{t(label)}:</span>
          {isVariationLoading ? (
            <Skeleton variant='text' sx={{ fontSize: '12px', bgcolor: '--table-body-text' }} width={40} />
          ) : (
            <span className={scss.value}>{variationScores[value] || '-/-'}</span>
          )}
        </div>
      ))}
    </div>
  );
}

export default ScoresSection;
